import instance from "../services";
import { CART_ADD_URL, DELIVERY_INFO_URL, COUPON_LIST_URL, DEPOSIT_LIST_URL, CART_DETAIL_URL } from "../../utils/urls";

const orderApi = {
        /**
         * 장바구니 담기
         * @returns {Promise<axios.AxiosResponse<any>>}
         */
        updateCartList(params) {
        return instance.post(CART_ADD_URL, params);
        },
        /**
         * 주문 결제 요약 정보 조회
         * @returns {Promise<axios.AxiosResponse<any>>}
         */
        getCartDetail(params) {
        return instance.post(CART_DETAIL_URL, params);
        },
        /**
         * 쿠폰리스트
         * settlePrice :: 합 금액
         * @returns {Promise<axios.AxiosResponse<any>>}
         */
        getCouponList(params) {
        return instance.post(COUPON_LIST_URL, params);
        },
    
        /**
         * 예치금 정보
         * @returns {Promise<axios.AxiosResponse<any>>}
         */
        getDepositList() {
        return instance.post(DEPOSIT_LIST_URL);
        },
        /**
         * 배송지 정보
         * @returns {Promise<axios.AxiosResponse<any>>}
         */
        getDefaultDeliveryInfo() {
        return instance.post(DELIVERY_INFO_URL);
        },
    
        /**
         * 은행 리스트
         * @returns {Promise<axios.AxiosResponse<any>>}
         */
        getBankList() {
        return instance.post('/bankList');
        },
    
        /**
         * 별점 정보
         * @returns {Promise<axios.AxiosResponse<any>>}
         */
        getRatingInfo() {
        return instance.post('/returnGradeInfo');
        },
        
        /**
         * 장바구니에 상품 추가
         * @param {number} goods_seq - 상품 시퀀스
         * @param {string} order_type - 주문 유형 (visit/parcel)
         * @param {number} ea - 수량
         * @param {Array} product_info - 상품 정보
         * @returns {Promise<axios.AxiosResponse<any>>}
         */
        addToCart(goods_seq, order_type, ea = 1, product_info = [], option_info = []) {
        return instance.post(CART_ADD_URL, {
            goods_seq,
            order_type,
            ea,
            product_info,
            option_info
        });
        },
    };

export default orderApi;